import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getInventoryItems } from '../../api/inventory';
import { ProductInventoryItem } from 'api/inventory-types';

const ProductDetails = () => {
    const { productId } = useParams();
    const navigate = useNavigate();
    const [inventoryItems, setInventoryItems] = useState<ProductInventoryItem[]>([]);
    const [error, setError] = useState('');

    useEffect(() => {
        loadInventoryItems();
    }, [productId]);

    const loadInventoryItems = async () => {
        try {
            const items = await getInventoryItems(productId!);
            setInventoryItems(items);
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold">Product Details</h2>
                <button
                    onClick={() => navigate('/admin/products')}
                    className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
                >
                    Back to Products
                </button>
            </div>

            <div className="bg-gray-100 border border-gray-300 rounded p-4 mb-6">
                <p className="text-sm text-gray-600">Product ID: <span className="font-mono">{productId}</span></p>
            </div>

            {error && (
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    {error}
                </div>
            )}

            <div className="bg-white shadow-md rounded-lg">
                <table className="min-w-full">
                    <thead>
                        <tr>
                            <th className="px-6 py-3 border-b">Instance ID</th>
                            <th className="px-6 py-3 border-b">Amount</th>
                            <th className="px-6 py-3 border-b">Created Date</th>
                            <th className="px-6 py-3 border-b">Instance Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        {inventoryItems.map(item => (
                            <tr key={item.instanceId}>
                                <td className="px-6 py-4 border-b font-mono">{item.instanceId}</td>
                                <td className="px-6 py-4 border-b">{item.amount}</td>
                                <td className="px-6 py-4 border-b">
                                    {new Date(item.createdDate).toLocaleDateString()}
                                </td>
                                <td className="px-6 py-4 border-b">
                                    <div className="space-y-1">
                                        {Object.entries(item.instanceData).map(([key, value]) => (
                                            <div key={key} className="flex gap-2">
                                                <span className="font-medium">{key}:</span>
                                                <span className="font-mono">{JSON.stringify(value)}</span>
                                            </div>
                                        ))}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProductDetails; 